export default {
  // hóa đơn
  saleinvoice: 'SASaleInvoice',
  saleinvoice: 'ElectronicTicketList',
  cancelInvoice: 'SASaleInvoice',
  // inventory: 'Inventory', // Phân hệ kho
  ininward: 'InventoryInInward', // Nhập kho
  inoutward: 'InventoryInOutward', // Xuất kho
  intransfer: 'InTransfer', // Chuyển kho
  inadjustment: 'InventoryInAjustment', // Điểu chỉnh tồn kho
  suincrement: 'InventoryItemSuincrement', // Ghi tăng CCDC
  sutransfer: 'InventoryItemSutransfer', // Điều chuyển CCDC
  sudecrement: 'InventoryItemSudecrement', // Ghi giảm CCDC
  statisticaldayoff: 'StatisticalDayOff', // Bảng tổng hợp ngày nghỉ/làm thêm/làm đêm
  otherincome: 'OtherIncome', // Thu nhập không thường xuyên
  paotheroutcome: 'PAOtherOutcome', // Khấu trừ không thường xuyên
  pasalary: 'Salary', // Bảng lương
  glpayrollexpensesalarylist: 'GLPayrollExpenseSalaryList', // Hạch toán chi phí lương
  PARetroSalary: 'PARetroSalary', // Bảng lương truy lĩnh
  papersonalincometax: 'CAPaymentPersonalIncomeTax', // Bảng tính thuế
  // mua hàng
  pupayment: 'PUPayment',
  puvendorpayment: 'PUVendorPayment',
  puinvoice: 'PuInvoice',
  invoicebot: 'InvoiceBot',
  // bán hàng
  careceiptsale: 'CAReceiptSale',
  sainvoice: 'SAInvoice',
  careceiptcustomer: 'CAReceiptCustom',
  sareturn: 'SAReturn',

  // kho bạc
  buplanreceipt: 'BUPlanReceipt', // nhận dự toán
  budgetplan: 'BuPlanWithDraw', // Rút dự toán
  transfer: 'BUTransfer', // chuyển khoản kho bạc
  buvoucherlist: 'BUVoucherList', // bảng kê chứng từ thanh toán
  careceiptplanwithdrawlist: 'CAReceiptPlanWithdraw', // nhập quỹ tiền mặt
  buplanwdadjustment: 'BUPlanWDAdjustment', // điều chỉnh kinh phí
  buplanadjustment: 'BUPlanAdjustment', // điều chỉnh dự toán
  bucommitment: 'BUCommitmentRequest', // cam kết chi
  bucommitmentrequesttab: 'BUCommitmentRequest',
  bucommitmentadjustmenttab: 'BUCommitmentRequest',
  buopeningcommitmenttab: 'BUCommitmentRequest',
  bubudgetreserve: 'BUBudgetReserve', // dự toán giữ lại
  buplanimport: 'BUCommitmentAdjustment', // nhập dự toán
  buplancancel: 'BUPlanCancel', // hủy dự toán

  // tiền mặt
  careceipt: 'CAReceipt', // phiếu thu
  capayment: 'CAPayment', // phiếu chi
  cafundinventory: 'CAFundInventory', // Kiểm kê quỹ NHANH3 15.08.2023
  
  // tiền gửi
  badeposit: 'BADeposit', // thu tiền gửi
  bawithdraw: 'BAWithdraw', // chi tiền gửi
  babanktransfer: 'BABankTransfer', // chuyển tiền nội bộ
  currency: 'Currency', // Loại tiền

  // danh mục
  systemaccounts: 'Account',
  employee: 'Employee',
  payrollitem: 'PayrollItem',
  employeetype: 'EmployeeType',
  budgetchapter: 'BudgetChapter',
  budgetgroupitem: 'BudgetGroupItem1',
  budgesourceproperty: 'BudgetGroupItem',
  budgetsource: 'BudgetSource',
  activity: 'Activity',
  budgetFees: 'BudgetFees',
  budgetitem: 'BudgetItem',
  fixedasset: 'FixedAsset',
  budgetkinditem: 'BudgetKindItem',
  inventorycategory: 'InventoryCategory',
  inventoryitem: 'InventoryItem1',
  currency: 'Currency',
  department: 'Department',
  typeoffund: 'TypeOfFund',
  bankinfocategory: 'TypeOfFundBank',
  bankinfo: 'BankInfo',
  statistic: 'Statistic',
  purchasepurpose: 'PurchasePurpose',
  accounttransfer: 'AccountTransfer',
  stock: 'Stock',
  autobusiness: 'AutoBusiness',
  customervendor: 'AccountingObject',
  accountingobjectcategory: 'AccountingObjectCategory',
  invoiceformnumber: 'InvoiceFormNumber',
  vouchertype: 'VoucherType',
  contract: 'Contract',
  project: 'Project',
  task: 'Task',
  topic: 'Topic',
  fundstructure: 'FundStructure',
  accountparallelrule: 'AccountParallelRule',
  defaultaccount: 'DefaultAccount',
  salaryscale: 'SalaryScale',
  budgetprovide: 'BudgetProvide',
  toollist: 'InventoryItem',
  tooltype: 'InventoryCategory1',
  option: 'PAOption',

  //hệ thống
  companyinfo: 'OrganizationInfo',
  usermanagement: 'UserManagement',
  datamanagement: 'DataManagement',
  sysrole: 'RoleManagement',
  dvcfile: 'DVCUser',
  dcsdfile: 'DVCUser', // Kho bạc điện tử

  //TSCĐ
  fatransfer: 'FATransfer', // Điều chuyển tài sản cố định
  faincrement: 'FAIncrement', // Nhận bằng hiện vật và ghi tăng TSCĐ
  fadecrement: 'FADecrement', // Ghi giảm TSCĐ
  fadepreciation: 'FADepreciation', // hao mòn
  fadevaluation: 'FADevaluation', // khấu hao
  fapurchaseincrement: 'FAPurchaseIncrement', // Mua và ghi tăng TSCĐ
  faadjustment: 'FaAdjustment', //Đánh giá lại TSCĐ
  farevenue: 'FARevenue', // Bán TSCĐ chưa thu tiền
  careceiptfixedasset: 'CAReceiptFixedAsset', //Phiếu thu bán TSCĐ
  badepositfixedasset: 'BADepositFixedAsset', //Thu tiền gửi từ bán TSCĐ
  fasaleinvoice: 'FASaleInvoice', //Bán TSCĐ chưa thu tiền
  assetqlts: 'QltsVoucher', // Màn danh sách TSCĐ có kết nối MISA QLTS

  //Thuế
  tacircularvat: 'TACircularVATDeclaration',
  taenterpriseincometax: 'TAEnterpriseIncomeTax', // Thuế thu nhập doanh nghiệp


  // Tổng hợp
  glvoucher: 'GLVoucher',
  glpostedvoucher: 'GLPostedVoucher',
  vouchersummarytable: 'VoucherSummaryTable',
  glprofitlosstransfer: 'GLProfitLossTransfer',
  endyeartransfer: 'EndYearTransfer',
  beginningyeartransfer: 'BeginningYearTransfer',
  crereplist: 'CreReport',
  crerepsettlementtab: 'CreReport',
  crerepexportlisttab: 'CRERepExportList',
  crerepexportlisttaxtab: 'CrerepexportListTax',
  openingSupplyEntry: 'OpeningSupplyEntry',


  // ================== Các màn Detail ==================
  // Kho bạc
  // Kho bạc - nhận dự  toán
  buplanreceiptdetail: 'BUPlanReceipt',
  // Kho bạc - rút dự toán
  buplanwithdrawtransferdetail: 'BuPlanWithDraw',
  buplanwithdrawcashdetail: 'BuPlanWithDraw',
  buplanwithdrawdepositdetail: 'BuPlanWithDraw',
  buplanwithdrawsalarytransferdetail: 'BuPlanWithDraw',
  // Kho bạc - Chuyển khoản kho bạc
  butransferdetail: 'BUTransfer',
  butransferdepositdetail: 'BUTransfer',
  butransfersalarydetail: 'BUTransfer',
  butreasuryfundtransferinsurancepaymentdetail: 'BUTransfer',
  pupaymentdetail: 'PUPayment',
  fapurchaseincrementdetail: 'FAPurchaseIncrement',
  puvendorpaymentdetail: 'PUVendorPayment',
  butreasuryfundtransfersalarydetail: 'BUTransfer',
  // Kho bạc - Bảng kê chứng từ thanh toán
  buvoucherlistplanneddetail: 'BUVoucherList',
  buvoucherlistnotplanneddetail: 'BUVoucherList',
  buvoucherlistrealexpensedetail: 'BUVoucherList',
  buvoucherlistreceipexpensedetail: 'BUVoucherList',
  buvoucherlistotherdetail: 'BUVoucherList',
  // Kho bạc - nhập quỹ tiền mặt
  careceiptplanwithdrawdetail: 'CAReceiptPlanWithdraw',
  // Kho bạc - điều chỉnh kinh phí
  buexpensewithdrawadjustmentdetail: 'BUPlanWDAdjustment',
  burealexpenseadjustmentdetail: 'BUPlanWDAdjustment',
  // Kho bạc - điều chỉnh dự toán
  buplanadjustmentdetail: 'BUPlanAdjustment',
  // Kho bạc - cam kết chi
  bucommitmentrequestdetail: 'BUCommitmentRequest',
  // Kho bạc - Dự toán giữ lại
  bubudgetreservedetail: 'BUBudgetReserve',
  // Kho bạc - Hủy dự toán
  buplancanceldetail: 'BUPlanCancel',

  // Tiền mặt
  // Tiền mặt - phiếu thu
  careceiptdetail: 'CAReceipt',
  // careceiptplanwithdrawdetail: 'CAReceiptPlanWithdraw', // Trùng phía trên
  careceiptwithdrawdetail: 'CAReceipt',
  careceiptcustomerdetail: 'CAReceiptCustom',
  careceiptfixedassetdetail: 'FARevenue',
  careceiptsaledetail: 'CAReceiptSale',
  // Tiền mặt - phiếu chi
  capaymentdetail: 'CAPayment',
  capaymentdepositdetail: 'CAPayment',
  // pupaymentdetail: 'PUPayment', // Trùng phía trên
  // fapurchaseincrementdetail: 'FAPurchaseIncrement', // Trùng phía trên
  // puvendorpaymentdetail: 'PUVendorPayment', // Trùng phía trên
  capaymentsalarydetail: 'CAPayment',
  // Tiền mặt - kiểm kê
  cafundinventorydetail: 'CAFundInventory',

  // Tiền gửi
  // Tiền gửi - Thu tiền gửi
  badepositdetail: 'BADeposit',
  // careceiptcustomerdetail: 'CAReceiptCustom', // Trùng phía trên
  // careceiptfixedassetdetail: 'FARevenue', // Trùng phía trên
  // capaymentdepositdetail: 'CAPayment', // Trùng phía trên
  // butransferdepositdetail: 'BUTransfer', // Trùng phía trên
  // careceiptsaledetail: 'CAReceiptSale', // Trùng phía trên
  // Tiền gửi - Chi tiền gửi
  bawithdrawdetail: 'BAWithdraw',
  bawithdrawsalarydetail: 'BAWithdraw',
  // puvendorpaymentdetail: 'PUVendorPayment', // Trùng phía trên
  // fapurchaseincrementdetail: 'FAPurchaseIncrement', // Trùng phía trên
  // pupaymentdetail: 'PUPayment', // Trùng phía trên
  // careceiptwithdrawdetail: 'CAReceipt', // Trùng phía trên
  // Tiền gửi - Chuyển tiền nội bộ
  babanktransferdetail: 'BABankTransfer',
  
  // Kho
  // Kho - Nhập kho
  // pupaymentdetail: 'PUPayment', // Trùng phía trên
  puinvoicedetail: 'PuInvoice',
  ininwarddetail: 'InventoryInInward',
  ininwardfrominadjustmentdetail: 'InventoryInInward', 
  ininwardfrominadjustmentchangeamountdetail: 'InventoryInInward', 
  // Kho - Xuất kho
  inoutwarddetail: 'InventoryInOutward',
  inoutwardfrominadjustmentdetail: 'InventoryInOutward', 
  inoutwardfrominadjustmentchangeamountdetail: 'InventoryInOutward', 
  // Kho - Chuyển kho
  intransferdetail: 'InTransfer',
  // Kho - Điều chỉnh tồn kho
  inadjustmentdetail: 'InventoryInAjustment',

  // Công cụ dụng cụ
  // Công cụ dụng cụ - Ghi tăng CCDC
  suincrementdetail: 'InventoryItemSuincrement', 
  // Công cụ dụng cụ - Điều chuyển CCDC
  sutransferdetail: 'InventoryItemSutransfer',
  // Công cụ dụng cụ - Ghi giảm CCDC
  sudecrementdetail: 'InventoryItemSudecrement',

  // Tài sản cố định
  // Tài sản cố định - Mua và ghi tăng
  // fapurchaseincrementdetail: 'FAPurchaseIncrement', // Trùng phía trên
  fainvoicefixedassetdetail: 'FAPurchaseIncrement',
  // Tài sản cố định - Nhận bằng hiện vật và ghi tăng
  faincrementdetail: 'FAIncrement',
  // Tài sản cố định - Điều chuyển  
  fatransferdetail: 'FATransfer',
  // Tài sản cố định - Đánh giá lại 
  faadjustmentdetail: 'FaAdjustment',
  // Tài sản cố định - Trích khấu hao 
  fadevaluationdetail: 'FADevaluation',
  // Tài sản cố định - Tính hao mòn
  // chưa tạo được chứng từ
  // Tài sản cố định - Ghi giảm
  fadecrementdetail: 'FADecrement',
  // Tài sản cố định - Doanh thu (Phiếu thu bán tscđ, Thu tiền gửi bán tscđ, Bán tscđ chưa thu tiền)
  // careceiptfixedassetdetail: 'FARevenue', // Trùng phía trên
  fasaleinvoicedetail: 'FASaleInvoice',

  // Tiền lương
  // Tiền lương - Bảng tổng hợp ngày nghỉ/làm thêm, làm đêm
  statisticaldayoffdetail: 'StatisticalDayOff',
  // Tiền lương - Thu nhập không thường xuyên
  paotherincomedetail: 'OtherIncome', 
  // Tiền lương - Khấu trừ không thường xuyên
  paotheroutcomedetail: 'PAOtherOutcome', 
  // Tiền lương - Bảng lương truy lĩnh
  paretrosalaryincreasedetail: 'PARetroSalary',
  // Tiền lương - Bảng lương
  pasalarydetail: 'Salary',
  // Tiền lương - Hạch toán chi phí lương
  glpayrollexpensedetail: 'GLPayrollExpenseSalaryList', 
  // Tiền lương - Bảng tính thuế
  papersonalincometaxdetail: 'CAPaymentPersonalIncomeTax', 

  // Mua hàng 
  // Mua hàng - Mua hàng trả tiền ngay
  // pupaymentdetail: 'PUPayment', // Trùng phía trên
  // Mua hàng - Mua hàng chưa thanh toán
  // puinvoicedetail: 'PuInvoice', // Trùng phía trên
  // Mua hàng - Trả tiền nhà cung cấp
  // puvendorpaymentdetail: 'PUVendorPayment', // Trùng phía trên
  // Mua hàng - Xử lý hóa đơn đầu vào
  // Không tạo được chứng từ

  // Bán hàng
  // Bán hàng - Bán hàng thu tiền ngay
  // careceiptsaledetail: 'CAReceiptSale', // Trùng phía trên
  // Bán hàng - Bán hàng chưa thu tiền  
  sainvoicedetail: 'SAInvoice',
  // Bán hàng - Thu tiền khách hàng
  // careceiptcustomerdetail: 'CAReceiptCustom', // Trùng phía trên
  // Bán hàng - Hàng bán trả lại
  sareturndetail: 'SAReturn',

  // Hóa đơn
  // Hóa đơn - Hóa đơn
  sasaleinvoicedetail: 'SASaleInvoice',
  // Hóa đơn - Hủy hóa đơn
  electronicticketdetail: 'Receipt', 
  // Hóa đơn - Biên lai
  // Không tạo đc chứng từ
  // Hóa đơn - Vé điện tử 
  // Trùng hủy hóa đơn

  // Thuế - không có màn detail

  // Tổng hợp
  // Tổng hợp - Chứng từ nghiệp vụ khác
  glgeneralvoucherdetail: 'GLVoucher', 
  glprovisionaltaxincomeenterprisedetail: 'ProvisionalTaxIncomeEnterprised',
  glfinaltaxincomeenterprisedetail: 'FinalTaxInComeEnterprise',
  batransferwithdrawdetail: 'BATransferWithDraw',
  batransferdepositdetail: 'BATransferDeposit',
  // Tổng hợp - Chứng từ ghi sổ
  glpostedvoucherdetail: 'GLPostedVoucher',
  // Tổng hợp - Bảng TH chứng từ cùng loại
  glvouchersummarytabledetail: 'VoucherSummaryTable',
  // Tổng hợp - Xác định kết quả hoạt động
  glprofitlosstransferdetail: 'GLProfitLossTransfer',
  // Tổng hợp - Kết chuyển số dư cuối năm
  glendyeartransferdetail: 'EndYearTransfer', 
  // Tổng hợp - Quyết toán số dư đầu năm
  glbeginningyeartransferdetail: 'BeginningYearTransfer',
  // Tổng hợp - Nộp báo cáo cho kho bạc
  crerepexportlistdetail: 'CRERepExportList',
  // Tổng hợp - Nộp báo cáo cho cơ quan thuế
  crerepexportlisttaxdetail: 'CrerepexportListTax',
  // Tổng hợp - Nộp báo cáo lên cấp trên - lỗi chưa vào được màn list

  // Số dư ban đầu
  // Số dư ban đầu - Số dư tài khoản
  opaccountbalancedetail: 'InitialBalance',
  // Số dư ban đầu - Số dư TK ngân hàng
  opbankaccountbalancedetail: 'InitialBalance',
  // Số dư ban đầu - Công nợ khách hàng
  opcustomerbalancelistdetail: 'InitialBalance',
  // Số dư ban đầu - Công nợ nhà cung cấp
  opsupplierbalancelistdetail: 'InitialBalance',
  // Số dư ban đầu - Công nợ cán bộ
  opemployeebalancelistdetail: 'InitialBalance',
  // Số dư ban đầu - Tồn kho vật tư hàng hóa
  opinventorybalancedetail: 'InitialBalance',

  // Nhập công cụ dụng cụ ban đầu
  openingsupplyentrydetail: 'OpeningSupplyEntry'
};
